export const COOKIE_POLICY_LINK = 'https://www.wix.com/about/cookie-policy'

export const GLOBAL_POLICY_CONTROL_SPEC =
  'specs.cookieConsent.PolicyByGlobalPrivacyControl'

export const TAG_MANAGER_CONSENT_POLICY_BY_GEO_CONFIG =
  'TagManagerConsentPolicyByGeo'
